import React, { useState,CSSProperties } from 'react';
import { Box, Button, Table, Thead, Tbody, Tr, Th, Td,useToast, Image, IconButton, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Flex, FormControl, FormLabel, Input, Textarea, Select } from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {deletejobPost, getJobPosts,getApplications, updateJobPosts} from './redux/postslice'
import ClipLoader from "react-spinners/ClipLoader";
import 'toastr/build/toastr.min.css';
import toastr from 'toastr'

import { UseSelector,useDispatch, useSelector } from 'react-redux';
const override = {
  display: "block",
  margin: "0 auto",

  borderColor: "red",
};


const Applicants=()=>{
    const toast=useToast();
    const [jobs,setJobs]=React.useState([])
    const dispatch=useDispatch();
    React.useEffect(()=>{
applications()
    },[])
const applications=async()=>{
let applicationres=await dispatch(getApplications())
if(getApplications.rejected.match(applicationres)){
    toast({
        title: "Server Error please try later",
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
}
if(getApplications.fulfilled.match(applicationres)){
console.log('applicationres')
console.log(applicationres)
setJobs(applicationres.payload.data.response)

}
}
const handleDownloadCV = ( pdfBuffer,fileName) => {
    
    const pdfBlob = new Blob([new Uint8Array(pdfBuffer)], { type: 'application/pdf' });
    const pdfDataUrl = URL.createObjectURL(pdfBlob);
    const anchor = document.createElement('a');
    anchor.href = pdfDataUrl;
    anchor.download = fileName; // Set the file name for download
    anchor.click();

    // Clean up
    URL.revokeObjectURL(pdfDataUrl);
  };
    return(
        <>
        <Box className="App" p={8} overflowX="auto">
      <header>
        <h1>Jobs</h1>
        <Table variant="simple" width="100%">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Email</Th>
           <Th>CV</Th>
            </Tr>
          </Thead>
          <Tbody>
            {jobs?.map((job) => (
              <Tr key={job?._id}>
                
                <Td>
                  <Flex align="center">
                    {/* <Image src={job.company_logo} alt="Company Logo" boxSize="50px" borderRadius="full" marginRight="1rem" /> */}
                    {job?.name}
                  </Flex>
                </Td>
                <Td>
                <Flex align="center">
                    {/* <Image src={job.company_logo} alt="Company Logo" boxSize="50px" borderRadius="full" marginRight="1rem" /> */}
                    {job?.email_address}
                  </Flex>
                  {/* <IconButton
                    aria-label="Delete"
                    icon={<DeleteIcon />}
                    colorScheme="red"
                    variant="ghost"
                    // onClick={() => handleDeleteJob(job?._id)}
                    marginRight="0.5rem"
                    /> */}
                  {/* <IconButton
                    aria-label="Edit"
                    icon={<EditIcon />}
                    onClick={() => handleEditJob(job)}
                    marginRight="0.5rem"
                    /> */}
                </Td>
                <Td>
                  <Flex align="center">
                    {/* <Image src={job.company_logo} alt="Company Logo" boxSize="50px" borderRadius="full" marginRight="1rem" /> */}
                    <Button onClick={() => handleDownloadCV(job?.pdfBuffer,job?.cv)}>Download CV</Button>
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </header>
      {/* Edit Job Modal */}
   
    </Box>
        </>
    )
}

export default Applicants